module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "policy"
  }, [_c('a', {
    on: {
      "click": _vm.back
    }
  }, [_c('img', {
    staticClass: "back_image_button",
    attrs: {
      "src": "/static/images/icons/black/back.png",
      "alt": "",
      "title": ""
    }
  })]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.terms)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button_full btyellow",
    style: (_vm.borderStyle),
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Back")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-18c385dc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18c385dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/terms-of-use.vue
// module id = 741
// module chunks = 0